import { create } from 'zustand';

interface MidCallNotesState {
  notes: string;
  isOpen: boolean;

  // Actions
  setNotes: (text: string) => void;
  togglePanel: () => void;
  openPanel: () => void;
  closePanel: () => void;
  clear: () => void;
}

export const useMidCallNotesStore = create<MidCallNotesState>((set) => ({
  notes: '',
  isOpen: false,

  setNotes: (text: string) => {
    set({ notes: text });
  },

  togglePanel: () => {
    set((s) => ({ isOpen: !s.isOpen }));
  },

  openPanel: () => {
    set({ isOpen: true });
  },

  closePanel: () => {
    set({ isOpen: false });
  },

  clear: () => {
    set({ notes: '', isOpen: false });
  },
}));
